module.exports = __webpack_public_path__ + "img/germany.702f527f.svg";